// Every bound — device storage and network requests alike — is at least 30 s. Values and
// rationale: CLAUDE.md "Every transport is bounded".
export const MIN_TIMEOUT_MS = 30_000;

export const DEFAULT_STORAGE_TIMEOUT_MS = 30_000;
export const DEFAULT_TRANSPORT_TIMEOUT_MS = 30_000;
export const SCORE_SYNC_TIMEOUT_MS = 30_000;
// The server's Cloud Function timeout. A GraphQL bound at or below it cuts off requests the server answers.
export const SERVER_FUNCTION_TIMEOUT_MS = 120_000;
// Every GraphQL operation but score sync; also its floor, so Remote Config can only raise it.
export const GRAPHQL_TRANSPORT_TIMEOUT_MS = 150_000;
// Signed uploads: a large video on a slow rink uplink takes minutes. Only a true hang should reach this.
export const LONG_TRANSPORT_TIMEOUT_MS = 30 * 60_000;

export const TIMEOUT_REMOTE_CONFIG_KEYS = {
  actionBufferMs: 'action_buffer_timeout_ms',
  syncAttemptsWriteMs: 'sync_attempts_write_timeout_ms',
  transportDefaultMs: 'transport_default_timeout_ms',
  transportGraphqlMs: 'transport_graphql_timeout_ms',
  scoreSyncMs: 'score_sync_timeout_ms',
  transportLongMs: 'transport_long_timeout_ms',
} as const;

export const TIMEOUT_DEFAULTS: Record<string, number> = {
  [TIMEOUT_REMOTE_CONFIG_KEYS.actionBufferMs]: DEFAULT_STORAGE_TIMEOUT_MS,
  [TIMEOUT_REMOTE_CONFIG_KEYS.syncAttemptsWriteMs]: DEFAULT_STORAGE_TIMEOUT_MS,
  [TIMEOUT_REMOTE_CONFIG_KEYS.transportDefaultMs]: DEFAULT_TRANSPORT_TIMEOUT_MS,
  [TIMEOUT_REMOTE_CONFIG_KEYS.transportGraphqlMs]: GRAPHQL_TRANSPORT_TIMEOUT_MS,
  [TIMEOUT_REMOTE_CONFIG_KEYS.scoreSyncMs]: SCORE_SYNC_TIMEOUT_MS,
  [TIMEOUT_REMOTE_CONFIG_KEYS.transportLongMs]: LONG_TRANSPORT_TIMEOUT_MS,
};
